import React, { useEffect, useId, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import './ProductPortionModal.css';

const ProductPortionModal = ({ portions, currency, getPortionPrice, selectedPortion, onClose, onSubmit, submitting = false }) => {
    const [draftPortion, setDraftPortion] = useState(selectedPortion);
    const dialogRef = useRef(null);
    const titleId = useId();

    useEffect(() => {
        const previousFocus = document.activeElement;
        const dialog = dialogRef.current;
        dialog.querySelector('input:checked')?.focus();

        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && !submitting) {
                event.preventDefault();
                onClose();
            }
            if (event.key === 'Tab') {
                const controls = [...dialog.querySelectorAll('input:checked, button')];
                const first = controls[0];
                const last = controls[controls.length - 1];
                if (event.shiftKey && document.activeElement === first) {
                    event.preventDefault();
                    last.focus();
                } else if (!event.shiftKey && document.activeElement === last) {
                    event.preventDefault();
                    first.focus();
                }
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {
            document.removeEventListener('keydown', handleKeyDown);
            previousFocus?.focus();
        };
    }, [onClose, submitting]);

    return createPortal(
        <div className="product-portion-modal">
            <button
                type="button"
                className="product-portion-modal__backdrop"
                aria-label="Close weight selection"
                tabIndex={-1}
                disabled={submitting}
                onClick={onClose}
            />
            <form
                ref={dialogRef}
                className="product-portion-modal__panel"
                role="dialog"
                aria-modal="true"
                aria-labelledby={titleId}
                onSubmit={(event) => {
                    event.preventDefault();
                    if (submitting) return;
                    const portion = portions.find((option) => option.portion === draftPortion);
                    if (portion) onSubmit(portion);
                }}
            >
                <h5 id={titleId}>Select weight</h5>
                <fieldset className="product-portion-modal__options" aria-label="Available weights">
                    {portions.map((portion) => (
                        <label className="product-portion-modal__option" key={portion.portion}>
                            <span className="product-portion-modal__label">
                                <span>{portion.portion}</span>
                                <span className="product-portion-modal__price">({currency} {getPortionPrice(portion)})</span>
                            </span>
                            <input
                                type="radio"
                                name={titleId}
                                value={portion.portion}
                                checked={draftPortion === portion.portion}
                                disabled={submitting}
                                onChange={() => setDraftPortion(portion.portion)}
                            />
                        </label>
                    ))}
                </fieldset>
                <div className="product-portion-modal__actions">
                    <button type="button" onClick={onClose} disabled={submitting}>Cancel</button>
                    <button type="submit" className="bg-color-primary text-white" disabled={submitting}>Submit</button>
                </div>
            </form>
        </div>,
        document.body
    );
};

export default ProductPortionModal;
